/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerNotificationPreferences
 */
export interface FreelancerNotificationPreferences {
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    messageNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    messageNotificationViaSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    messageNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    missionProposalNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    missionProposalNotificationViaSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    missionProposalNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    automaticSourcingNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    automaticSourcingNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    callForSourcingNotificationViaPhone: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    newsletterViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    newsletterViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    eventNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    eventNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerServiceDiscoveryViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerServiceDiscoveryViaPhone: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerServiceDiscoveryViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerAdvancedServiceViaEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerAdvancedServiceViaPhone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    recommendationReceivedNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    recommendationReceivedNotificationViaSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerPersonalStatsViaEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    freelancerNetworkStatsViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    awakenProfileNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    awakenProfileNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerNotificationPreferences
     */
    applicationUpdatesNotificationViaEmail: boolean;
}

/**
 * Check if a given object implements the FreelancerNotificationPreferences interface.
 */
export function instanceOfFreelancerNotificationPreferences(value: object): value is FreelancerNotificationPreferences {
    if (!('messageNotificationViaEmail' in value) || value['messageNotificationViaEmail'] === undefined) return false;
    if (!('messageNotificationViaSms' in value) || value['messageNotificationViaSms'] === undefined) return false;
    if (!('messageNotificationViaPushMobile' in value) || value['messageNotificationViaPushMobile'] === undefined) return false;
    if (!('missionProposalNotificationViaEmail' in value) || value['missionProposalNotificationViaEmail'] === undefined) return false;
    if (!('missionProposalNotificationViaSms' in value) || value['missionProposalNotificationViaSms'] === undefined) return false;
    if (!('missionProposalNotificationViaPushMobile' in value) || value['missionProposalNotificationViaPushMobile'] === undefined) return false;
    if (!('automaticSourcingNotificationViaEmail' in value) || value['automaticSourcingNotificationViaEmail'] === undefined) return false;
    if (!('automaticSourcingNotificationViaPushMobile' in value) || value['automaticSourcingNotificationViaPushMobile'] === undefined) return false;
    if (!('callForSourcingNotificationViaPhone' in value) || value['callForSourcingNotificationViaPhone'] === undefined) return false;
    if (!('newsletterViaEmail' in value) || value['newsletterViaEmail'] === undefined) return false;
    if (!('newsletterViaPushMobile' in value) || value['newsletterViaPushMobile'] === undefined) return false;
    if (!('eventNotificationViaEmail' in value) || value['eventNotificationViaEmail'] === undefined) return false;
    if (!('eventNotificationViaPushMobile' in value) || value['eventNotificationViaPushMobile'] === undefined) return false;
    if (!('freelancerServiceDiscoveryViaEmail' in value) || value['freelancerServiceDiscoveryViaEmail'] === undefined) return false;
    if (!('freelancerServiceDiscoveryViaPhone' in value) || value['freelancerServiceDiscoveryViaPhone'] === undefined) return false;
    if (!('freelancerServiceDiscoveryViaPushMobile' in value) || value['freelancerServiceDiscoveryViaPushMobile'] === undefined) return false;
    if (!('recommendationReceivedNotificationViaEmail' in value) || value['recommendationReceivedNotificationViaEmail'] === undefined) return false;
    if (!('recommendationReceivedNotificationViaSms' in value) || value['recommendationReceivedNotificationViaSms'] === undefined) return false;
    if (!('freelancerNetworkStatsViaEmail' in value) || value['freelancerNetworkStatsViaEmail'] === undefined) return false;
    if (!('awakenProfileNotificationViaEmail' in value) || value['awakenProfileNotificationViaEmail'] === undefined) return false;
    if (!('awakenProfileNotificationViaPushMobile' in value) || value['awakenProfileNotificationViaPushMobile'] === undefined) return false;
    if (!('applicationUpdatesNotificationViaEmail' in value) || value['applicationUpdatesNotificationViaEmail'] === undefined) return false;
    return true;
}

export function FreelancerNotificationPreferencesFromJSON(json: any): FreelancerNotificationPreferences {
    return FreelancerNotificationPreferencesFromJSONTyped(json, false);
}

export function FreelancerNotificationPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerNotificationPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'messageNotificationViaEmail': json['messageNotificationViaEmail'],
        'messageNotificationViaSms': json['messageNotificationViaSms'],
        'messageNotificationViaPushMobile': json['messageNotificationViaPushMobile'],
        'missionProposalNotificationViaEmail': json['missionProposalNotificationViaEmail'],
        'missionProposalNotificationViaSms': json['missionProposalNotificationViaSms'],
        'missionProposalNotificationViaPushMobile': json['missionProposalNotificationViaPushMobile'],
        'automaticSourcingNotificationViaEmail': json['automaticSourcingNotificationViaEmail'],
        'automaticSourcingNotificationViaPushMobile': json['automaticSourcingNotificationViaPushMobile'],
        'callForSourcingNotificationViaPhone': json['callForSourcingNotificationViaPhone'],
        'newsletterViaEmail': json['newsletterViaEmail'],
        'newsletterViaPushMobile': json['newsletterViaPushMobile'],
        'eventNotificationViaEmail': json['eventNotificationViaEmail'],
        'eventNotificationViaPushMobile': json['eventNotificationViaPushMobile'],
        'freelancerServiceDiscoveryViaEmail': json['freelancerServiceDiscoveryViaEmail'],
        'freelancerServiceDiscoveryViaPhone': json['freelancerServiceDiscoveryViaPhone'],
        'freelancerServiceDiscoveryViaPushMobile': json['freelancerServiceDiscoveryViaPushMobile'],
        'freelancerAdvancedServiceViaEmail': json['freelancerAdvancedServiceViaEmail'] == null ? undefined : json['freelancerAdvancedServiceViaEmail'],
        'freelancerAdvancedServiceViaPhone': json['freelancerAdvancedServiceViaPhone'] == null ? undefined : json['freelancerAdvancedServiceViaPhone'],
        'recommendationReceivedNotificationViaEmail': json['recommendationReceivedNotificationViaEmail'],
        'recommendationReceivedNotificationViaSms': json['recommendationReceivedNotificationViaSms'],
        'freelancerPersonalStatsViaEmail': json['freelancerPersonalStatsViaEmail'] == null ? undefined : json['freelancerPersonalStatsViaEmail'],
        'freelancerNetworkStatsViaEmail': json['freelancerNetworkStatsViaEmail'],
        'awakenProfileNotificationViaEmail': json['awakenProfileNotificationViaEmail'],
        'awakenProfileNotificationViaPushMobile': json['awakenProfileNotificationViaPushMobile'],
        'applicationUpdatesNotificationViaEmail': json['applicationUpdatesNotificationViaEmail'],
    };
}

export function FreelancerNotificationPreferencesToJSON(value?: FreelancerNotificationPreferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'messageNotificationViaEmail': value['messageNotificationViaEmail'],
        'messageNotificationViaSms': value['messageNotificationViaSms'],
        'messageNotificationViaPushMobile': value['messageNotificationViaPushMobile'],
        'missionProposalNotificationViaEmail': value['missionProposalNotificationViaEmail'],
        'missionProposalNotificationViaSms': value['missionProposalNotificationViaSms'],
        'missionProposalNotificationViaPushMobile': value['missionProposalNotificationViaPushMobile'],
        'automaticSourcingNotificationViaEmail': value['automaticSourcingNotificationViaEmail'],
        'automaticSourcingNotificationViaPushMobile': value['automaticSourcingNotificationViaPushMobile'],
        'callForSourcingNotificationViaPhone': value['callForSourcingNotificationViaPhone'],
        'newsletterViaEmail': value['newsletterViaEmail'],
        'newsletterViaPushMobile': value['newsletterViaPushMobile'],
        'eventNotificationViaEmail': value['eventNotificationViaEmail'],
        'eventNotificationViaPushMobile': value['eventNotificationViaPushMobile'],
        'freelancerServiceDiscoveryViaEmail': value['freelancerServiceDiscoveryViaEmail'],
        'freelancerServiceDiscoveryViaPhone': value['freelancerServiceDiscoveryViaPhone'],
        'freelancerServiceDiscoveryViaPushMobile': value['freelancerServiceDiscoveryViaPushMobile'],
        'freelancerAdvancedServiceViaEmail': value['freelancerAdvancedServiceViaEmail'],
        'freelancerAdvancedServiceViaPhone': value['freelancerAdvancedServiceViaPhone'],
        'recommendationReceivedNotificationViaEmail': value['recommendationReceivedNotificationViaEmail'],
        'recommendationReceivedNotificationViaSms': value['recommendationReceivedNotificationViaSms'],
        'freelancerPersonalStatsViaEmail': value['freelancerPersonalStatsViaEmail'],
        'freelancerNetworkStatsViaEmail': value['freelancerNetworkStatsViaEmail'],
        'awakenProfileNotificationViaEmail': value['awakenProfileNotificationViaEmail'],
        'awakenProfileNotificationViaPushMobile': value['awakenProfileNotificationViaPushMobile'],
        'applicationUpdatesNotificationViaEmail': value['applicationUpdatesNotificationViaEmail'],
    };
}

